import React from 'react';
import styled from "styled-components";
import ConvertPixelToRem from "@helpers/convert.rem";
import {shortMoneyNumber, shortAreaNumber, shortAgeNumber, handleFormatNumbers} from "@helpers/numbers";
import {isEmpty, str_replace} from "../../../helpers/helpers";

function Caption({type, label, items, unit, caption_show, selected_range, showRangeInputInCaption, setItemsPosition, showLabelAndSelected, clearabel}) {

    const getCaption = () => {
        let caption = (showLabelAndSelected) ? '' : label;
        if (type !== 'range') {
            const {options} = items;
            let new_caption = [];
            const show = (typeof caption_show !== "undefined") ? caption_show : 3;

            for (let key in options) {
                if (options[key]['checked'] !== undefined && options[key]['checked'] === true) {
					if (label !== 'طبقه') {
						new_caption.push(options[key]['label']);
					} else if (label === 'طبقه') {
						if (options[key]['label'].includes('طبقه')) {
							new_caption.push(options[key]['label'].replace('طبقه', ''));
						} else {
							new_caption.push(options[key]['label']);
						}
					}
                }
            }

            const new_caption_length = new_caption.length;
            if (new_caption_length > 0) {
                if (!showLabelAndSelected && new_caption_length > show) {
                    caption = caption + ' (' + new_caption_length + ')'
                } else if (showLabelAndSelected && new_caption_length > show) {
                    caption = new_caption.slice(0, show).join('، ') + ' (' + (new_caption_length - show) + '+)';
                } else {
                    caption = new_caption.join('، ');
                }
            }
        } else {
            const {min, max} = selected_range;
            let minValue = min ? String(min) : null;
            let maxValue = max ? String(max) : null;

            if (minValue !== null || maxValue !== null) {
                caption = '';
            }

            let convertMinValue, convertMaxValue, unitName;

            switch (unit) {
                case 'money':
                    convertMinValue = shortMoneyNumber(minValue);
                    convertMaxValue = shortMoneyNumber(maxValue);

                    unitName = "";
                    break;
                case 'area':
                    convertMinValue = shortAreaNumber(minValue);
                    convertMaxValue = shortAreaNumber(maxValue);
                    unitName = "";
                    break;
                case 'age':
                    convertMinValue = shortAgeNumber(minValue);
                    convertMaxValue = shortAgeNumber(maxValue);
                    unitName = "";
                    break;
            }

            let minValueUnit = convertMinValue.unit;
            let maxValueUnit = convertMaxValue.unit;

            if (minValueUnit === maxValueUnit && Number(str_replace('٫','',convertMaxValue.num)) > 0) {
                minValueUnit = '';
            }

			if ((!isEmpty(minValue) || !isEmpty(maxValue)) && (label === 'اجاره' || label === 'رهن')) {
				caption += label + ' ';
			}

            if (minValue) {
                if (!maxValue) {
                    caption += 'از ';
                }

                let minNumber = convertMinValue.num;
                caption += minNumber;

                if (minValueUnit !== '') {
                    caption += ' ' + minValueUnit + ' ';
                }
            }

            if (maxValue) {
                let maxNumber = convertMaxValue.num;
                caption += ' تا ';
                caption += maxNumber;
                caption += ' ' + maxValueUnit + ' ';
            }

            if (unitName !== "") {
                caption += ' ' + unitName + ' ';
            }
        }

        return caption;
    };

    return (
        <CaptionContainer className={"selection-caption " + (showLabelAndSelected ? 'd-flex align-items-center justify-content-between ' : '') + (clearabel ? '' : 'modal-filter-pl-32')}>
            {
                (type === 'range' && typeof showRangeInputInCaption !== "undefined" && showRangeInputInCaption)
                    ?
                    <InputGroup className="d-flex align-items-center">
                        <RangeInput>
                            <label htmlFor="">حداقل</label>
                            <input type="text" readOnly="readOnly" defaultValue={(typeof selected_range.min !== "undefined" && selected_range.min !== '') ? handleFormatNumbers(String(selected_range.min)) : ''} className="form-control text-center" placeholder="مهم نیست" onFocus={() => setItemsPosition('right')}/>
                        </RangeInput>

                        <span className="dash mx-8">تا</span>

                        <RangeInput>
                            <label htmlFor="">حداکثر</label>
                            <input type="text" readOnly="readOnly" defaultValue={(typeof selected_range.max !== "undefined" && selected_range.max !== '') ? handleFormatNumbers(String(selected_range.max)) : ''} className="form-control text-center" placeholder="مهم نیست" onFocus={() => setItemsPosition('left')}/>
                        </RangeInput>
                    </InputGroup>
                    :
                    <React.Fragment>
                        {
                            (showLabelAndSelected) ?
                                <React.Fragment>
                                    <span>{label}</span>
                                    <span className="font-weight-bold selected-label">{getCaption()}</span>
                                </React.Fragment>
                                :
                                getCaption()
                        }
                    </React.Fragment>

            }

        </CaptionContainer>
    )
}

export default React.memo(Caption);

// styles

const RangeInput = styled.div`
    width: 100%;
    padding: 8px;
    border-radius: 8px;
    border: 1px solid ${props => props.theme.gray300};
    
    label {
        margin: 0 !important;
        display: block !important;
        font-size: .875rem;
        font-weight: normal;
        line-height: 1.36;
        text-align: right;
        color: #717171;
    }

    input {
        border: none !important;
        padding: 0;
        width: 100%;
        font-size: ${props => props.theme.fontSizeBase} !important;
        font-weight: 300;
        height: auto !important;
        text-align: right !important;
        line-height: 1.8;
        color: ${props => props.theme.black};
    }
`;
const InputGroup = styled.div`
    .dash {
        font-size: ${props => props.theme.fontSizeBase};
        line-height: 1.8;
        text-align: right;
        color: ${props => props.theme.black};
    }
`;

export const CaptionContainer = styled.div`
  width: 100%;
  font-size: ${ConvertPixelToRem(15)};
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.36;
  letter-spacing: normal;
  color: ${props => props.theme.black};
`;